// extracted by mini-css-extract-plugin
export default {"form":"DiscountMarkup_form__HEQNH","gridRow":"DiscountMarkup_gridRow__Cict2","field":"DiscountMarkup_field__TyTMZ","label":"DiscountMarkup_label__qMNNr"};